<script>
  import { onMount } from "svelte";
  import mq from "../stores/mq.js"; // here, defined laptop = 992px

  export let baseImage;
  export let scenesWithOverlays;
  export let currentOverlays;
  export let mainAltText;
  // $: console.log(currentOverlays)
</script>

<div class="scene-img {$mq.classNames}">
  <div class="img-wrapper">
    <img alt={mainAltText} src={baseImage} class="background"/>
  </div>
  <div class="scene-overlays">
    {#each scenesWithOverlays as sceneOverlays, i}
      {#each sceneOverlays.overlays as overlayImg, j}
        <img alt="" src={overlayImg} class="overlay" style="opacity: {currentOverlays.includes(overlayImg) ? sceneOverlays.overlayOpacity[j] : 0}" />
      {/each}
    {/each}
  </div>
</div>

<style>

  /* .img-wrapper {
    padding-bottom: calc(3323 / 3000 * 100%);
  } */
  .scene-img {
    display: block;
  }

  .scene-img img {
    max-height: 100vh;
    /* max-height: calc(var(--vh, 1vh) * 100); */
    max-width: 90vw;
    object-fit: contain;
  }

  .scene-img.mq-laptop img{ 
    max-width: 70vw;
  }

  .scene-img.mq-shortDesktop img {
    max-height: var(--minHeight);
  }
  .background {
    z-index: var(--z-bottom);
  }

  .overlay {
    position: absolute;
    z-index: var(--z-middle);
    top: 0;
    transition: opacity 1s;
  }

  .scene-img.mq-mobile .overlay {
    transition: none;
  }
</style>
